import { useContext, useState, useCallback, useEffect } from 'react';
import { useIdentity } from '@vp/auth-react';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { API_ENDPOINTS } from './src-config-api-config.js';
import { transformChatContextResponse } from './src-utils-chat-chat-case-transform-utils.js';
import { CAContext } from './src-contexts-CAContext.js';
import { getRestId } from './src-utils-session-storage-utils.js';

const useChatCaseDetails = () => {
  const {
    chatState: { locale }
  } = useContext(CAContext);
  const identity = useIdentity();
  const { logCustomAttributesNR } = useNRLogging();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [requestData, setRequestData] = useState();
  const trigger = useCallback((chatDetails) => {
    setRequestData(chatDetails);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (requestData) {
        try {
          setLoading(true);
          const { authorizationHeader } = identity;
          const myHeaders = new Headers();
          myHeaders.append("Authorization", authorizationHeader || "");
          myHeaders.append("Content-Type", "application/json");
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(requestData),
            redirect: "follow"
          };
          logCustomAttributesNR("ca-chatbot-misc-api-request", {
            logLevel: "info",
            message: "Getting Chat Case Details",
            requestData: JSON.stringify(requestData),
            apiType: "getChatContext"
          });
          const requestURL = new URL(`${API_ENDPOINTS.CONCORD_BASE_URL()}/context-builder`);
          requestURL.searchParams.append("request_id", getRestId());
          fetch(requestURL, requestOptions).then((response) => {
            if (!response.ok) {
              const error2 = new Error(`API responded with status: ${response.status}`);
              error2.name = "ApiError";
              throw error2;
            }
            return response.json();
          }).then((result) => {
            const { caseData, queueInfo } = transformChatContextResponse(result);
            setData({ caseData, queueInfo });
            setError(void 0);
          }).catch((error2) => {
            setError(error2);
            console.error(error2);
            setData({
              caseData: {
                banner: "VP",
                brand: "VP",
                caseOrigin: `VistaPrint-ChatAnywhere-${locale?.toUpperCase()}-${requestData.pageName}`,
                chatLocale: locale,
                pageName: requestData.pageName,
                pageSection: requestData.pageSection,
                pageStage: requestData.pageStage,
                pagePath: window?.location.pathname,
                pageURL: window?.location.href,
                category: "#Others",
                subCategory: "#Others",
                description: `${requestData.pageName} Case`,
                priority: "Medium",
                status: "In Progress",
                subject: `Chat - ${requestData.pageName}`
              },
              queueInfo: "default"
            });
            logCustomAttributesNR("ca-chatbot-misc-api-error", {
              errorName: error2?.name,
              errorStack: error2?.stack,
              message: error2?.message,
              logLevel: "error",
              apiType: "getChatContext"
            });
          }).finally(() => {
            setLoading(false);
            setRequestData(void 0);
          });
        } catch (err) {
          setError(err);
        }
      }
    };
    fetchData();
  }, [requestData]);
  return {
    data,
    loading,
    error,
    trigger
  };
};

export { useChatCaseDetails };
//# sourceMappingURL=src-hooks-utility-hooks-useChatCaseDetails.js.map
